import { cn } from "@/lib/utils";

export default function PageHeader({ title, description, actions, className, children }) {
  return (
    <div
      className={cn(
        "px-4 sm:px-6 py-4 sm:py-5 border-b border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3",
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="font-heading font-black text-2xl sm:text-3xl tracking-tight">{title}</h1>
        {description && <p className="text-muted-foreground text-sm mt-0.5">{description}</p>}
      </div>
      {(actions || children) && (
        <div className="flex items-center gap-2 flex-wrap shrink-0">{actions || children}</div>
      )}
    </div>
  );
}
